import * as React from "react";
import {TransportOrder} from "../../../../../../generated/api";
import {TransportOrderImportFiles} from "./TransportOrderImportFiles";
import {Tab} from "semantic-ui-react";
import {TransportOrderExportFiles} from "./TransportOrderExportFiles";
import {ConfigContext} from "../../../../context/ConfigContext";
import {clampTabIndex} from "../../../../context/TabSession";


export interface TransportOrderFilesTabViewProps {
    order: TransportOrder | null;
    history: any;
}

export function TransportOrderTabViewFiles(props: React.PropsWithChildren<TransportOrderFilesTabViewProps>) {

    const context = React.useContext(ConfigContext);

    const panes = [
        {
            menuItem: 'Import',
            render: () =>
                <Tab.Pane id={"ImportFilesTab"} className={"flex1"}>
                    <TransportOrderImportFiles
                        order={props.order}
                        history={props.history}
                    />
                </Tab.Pane>
        },
        {
            menuItem: 'Export',
            render: () =>
                <Tab.Pane id={"ExportFilesTab"} className={"flex1"}>
                    <TransportOrderExportFiles
                        order={props.order}
                        history={props.history}
                    />
                </Tab.Pane>
        }]

    return <Tab
        id={"TransportOrderFilesTabMenu"}
        panes={panes}
        defaultActiveIndex={clampTabIndex(context.tabSession.transportOrderFilesTab, panes)}
        onTabChange={(_, data) => {
            context.setSingleTabSession("transportOrderFilesTab", parseInt(data.activeIndex.toString()))
        }}
    />
}
